import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { VictoryChart, VictoryLine, VictoryScatter, VictoryAxis, VictoryTooltip, VictoryZoomContainer, VictoryBrushContainer, VictoryLabel } from 'victory';
import theme from 'themes/victoryChartTheme';

const BrushChart = props => {
  let { width, height } = props.chartSize;
  let adjustedBrushDomain = props.selectedDomain
  // adjustedBrushDomain.y = [0,props.getHighestValueForComparison(props.data) * 1.1]
  if (props.series1Data.length < 10) {
    adjustedBrushDomain.x = [1,props.series1Data.length]
  }
  return (
    <VictoryChart
      domainPadding={{x:2, y:[0,5]}}
      padding={{top: 0, left: 50, right: 50, bottom: 30}}
      theme={theme}
      width={width} height={height*0.15}
      containerComponent={
        <VictoryBrushContainer
          brushDimension="x"
          brushDomain={adjustedBrushDomain}
          brushStyle={{stroke: "3395FF", strokeWidth: "1", fill: "3395FF", fillOpacity: 0.2}}
          onBrushDomainChange={props.handleBrush}
          style={{padding: "0px 0px 10px 20px", backgroundColor: 'white'}}
        />
      }
    >
      {/* Axis for Brush Chart  */}
      <VictoryAxis
        tickCount={5} />
      <VictoryAxis
        dependentAxis
        tickCount={5}
        tickFormat={(x) => ''}
      />
      {/* Conditional Render of Line Chart for SERIES1  */}
      { props.series1Data &&
        <VictoryLine
          style={{
            data: {stroke: props.colors['series1']}
          }}
          labelComponent={<VictoryTooltip/>}
          data={props.series1Data}
          x="index"
          y="value" />
      }
      {/* Conditional Render of Line Chart for SERIES2  */}
      { (props.selectedSeries2 && props.series2Data) &&
        <VictoryLine
          style={{
            data: {stroke: props.colors['series2']}
          }}
          labelComponent={<VictoryTooltip/>}
          data={props.series2Data}
          x="index"
          y="value" />
      }
      {/* Conditional Render of Line Chart for SERIES3  */}
      { (props.selectedSeries3 && props.series3Data) &&
        <VictoryLine
          style={{
            data: {stroke: props.colors['series3']}
          }}
          labelComponent={<VictoryTooltip/>}
          data={props.series3Data}
          x="index"
          y="value" />
      }
    </VictoryChart>
  );
}

export default BrushChart;



// WEBPACK FOOTER //
// ./src/scripts/components/series/seriesComparison/BrushChart.js